export default __webpack_public_path__ + "47782f66d1535629f8ee7fbb8d4a97ef.png";